(() => {
  const dialog = document.getElementById('ls-language-prompt');
  const configuration = document.getElementById('ls-language-prompt-config');
  const data = window.LukeSolveLanguageData;
  if (!dialog || !configuration || !data || !dialog.showModal) return;
  const config = JSON.parse(configuration.textContent);
  const available = new Set(config.available);
  if (config.language !== 'en') { dialog.dataset.status = 'not-english'; return; }
  const duration = 7 * 24 * 60 * 60 * 1000;
  const storageKey = 'lukesolve_language_prompt_shown_at';
  const preview = window.Shopify?.theme?.role === 'unpublished';
  const parameters = new URLSearchParams(location.search);
  const previewCountry = preview ? parameters.get('ls_language_preview')?.toUpperCase() : null;
  const ignoreCooldown = Boolean(previewCountry && parameters.get('ls_language_replay') === '1');
  const readTimestamp = () => {
    let saved = 0;
    try { saved = Number(localStorage.getItem(storageKey)) || 0; } catch {}
    const match = document.cookie.split('; ').find(value => value.startsWith(storageKey + '='));
    const cookie = match ? Number(match.slice(storageKey.length + 1)) || 0 : 0;
    return Math.max(saved, cookie);
  };
  const recent = () => {
    const saved = readTimestamp();
    return saved > 0 && Date.now() - saved < duration;
  };
  const rememberShown = () => {
    const timestamp = String(Date.now());
    try { localStorage.setItem(storageKey, timestamp); } catch {}
    try { document.cookie = `${storageKey}=${timestamp}; Max-Age=604800; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`; } catch {}
    return readTimestamp() > 0;
  };
  if (recent() && !ignoreCooldown) { dialog.dataset.status = 'cooldown'; return; }
  const form = document.getElementById('LsLanguagePromptForm');
  const heading = dialog.querySelector('.ls-language-prompt__heading');
  const descriptions = dialog.querySelector('[data-ls-language-descriptions]');
  const topFlags = dialog.querySelector('[data-ls-language-flags]');
  const primaryButtons = dialog.querySelector('[data-ls-language-primary]');
  const otherButtons = dialog.querySelector('[data-ls-language-other]');
  const allButtons = dialog.querySelector('[data-ls-language-all]');
  const createElement = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const switchLanguage = (code, primary) => {
    if (!available.has(code) || dialog.dataset.switching === 'true') return;
    try { window.LukeSolveLanguageReporting?.choose(code, primary); } catch {}
    const returnUrl = new URL(location.href);
    returnUrl.searchParams.delete('ls_language_preview');
    returnUrl.searchParams.delete('ls_language_replay');
    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.append(returnInput);
    }
    returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    form.querySelector('input[name="language_code"]').value = code;
    if (!ignoreCooldown) rememberShown();
    dialog.dataset.switching = 'true';
    try { localStorage.setItem('lukesolve_language_changed_at', String(Date.now())); } catch {}
    form.submit();
  };
  const makeButton = (code, primary = false) => {
    const language = data.languages[code];
    const button = createElement('button', '', primary ? 'ls-language-prompt__button' : '');
    button.type = 'button';
    button.dataset.language = code;
    button.append(createElement('span', primary ? config.button.replace('[language]', language.name) : language.name));
    const flag = createElement('span', language.flag, 'ls-language-prompt__flag');
    flag.setAttribute('aria-hidden', 'true');
    button.append(flag);
    button.addEventListener('click', () => switchLanguage(code, primary));
    return button;
  };
  for (const close of dialog.querySelectorAll('[data-ls-language-close]')) close.addEventListener('click', () => {
    try {
      if (close.classList.contains('ls-language-prompt__keep')) window.LukeSolveLanguageReporting?.keepEnglish();
      else window.LukeSolveLanguageReporting?.dismiss('close');
    } catch {}
    dialog.close();
  });
  dialog.addEventListener('cancel', () => {
    try { window.LukeSolveLanguageReporting?.dismiss('escape'); } catch {}
  });
  dialog.addEventListener('close', () => {
    try { window.LukeSolveLanguageReporting?.hidden(); } catch {}
  });
  window.addEventListener('storage', event => { if (event.key === storageKey && dialog.open && !ignoreCooldown) dialog.close(); });
  const visibleBlocker = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')).some(element => {
    if (element === dialog || dialog.contains(element)) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.checkVisibility && !element.checkVisibility({checkOpacity:true, checkVisibilityCSS:true})) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0;
  });
  const show = (country) => {
    dialog.dataset.detectedCountry = country;
    const record = data.countries[country];
    const primary = (record?.primary || []).filter(code => available.has(code));
    if (!primary.length) { dialog.dataset.status = 'no-primary-language'; return; }
    const shares = record?.speakerPercent || {};
    const overSingleThreshold = primary.some(code => Number(shares[code]) > data.eligibility?.singleLanguagePercent);
    const official = primary.filter(code => (record?.officialPrimary || []).includes(code));
    const combinedOfficialPercent = official.reduce((sum, code) => sum + (Number(shares[code]) || 0), 0);
    const overOfficialThreshold = official.length > 1 && combinedOfficialPercent > data.eligibility?.multipleOfficialPercent;
    if (!overSingleThreshold && !overOfficialThreshold) { dialog.dataset.status = 'population-threshold'; return; }
    dialog.dataset.status = 'waiting-for-visible-page';
    heading.textContent = primary.length === 1 ? config.heading.replace('[language]', data.languages[primary[0]].name) + '?' : config.multipleHeading;
    descriptions.hidden = primary.length > 1;
    for (const code of primary) {
      const language = data.languages[code];
      topFlags.append(createElement('span', language.flag));
      if (primary.length === 1) {
        const description = createElement('p', language.description);
        description.lang = code;
        description.dir = language.dir;
        descriptions.append(description);
      }
      primaryButtons.append(makeButton(code, true));
    }
    const regional = (record.other || []).filter(code => available.has(code) && !primary.includes(code));
    const defaults = ['es', 'pt-BR', 'hi', 'id', 'fr', 'de'];
    const quick = Array.from(new Set([...regional, ...defaults.filter(code => available.has(code) && !primary.includes(code))]));
    for (const code of quick.slice(0, Math.max(4, regional.length))) otherButtons.append(makeButton(code));
    for (const code of Object.keys(data.languages).filter(code => available.has(code) && !primary.includes(code)).sort((a,b) => data.languages[a].name.localeCompare(data.languages[b].name))) allButtons.append(makeButton(code));
    const attempt = () => {
      if (recent() && !ignoreCooldown) { observer?.disconnect(); return; }
      if (document.visibilityState !== 'visible' || visibleBlocker()) return;
      if (!ignoreCooldown && !rememberShown()) { observer?.disconnect(); return; }
      dialog.showModal();
      dialog.dataset.status = 'shown';
      try { window.LukeSolveLanguageReporting?.shown(country, primary); } catch {}
      primaryButtons.querySelector('button')?.focus();
      observer?.disconnect();
    };
    let observer = new MutationObserver(attempt);
    observer.observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden','aria-hidden','open'] });
    document.addEventListener('visibilitychange', attempt, { once:true });
    attempt();
    setTimeout(() => observer.disconnect(), 120000);
  };
  if (previewCountry && data.countries[previewCountry]) { show(previewCountry); return; }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 6000);
  const root = window.Shopify?.routes?.root || '/';
  dialog.dataset.status = 'location-loading';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {credentials:'same-origin',signal:controller.signal})
    .then(response => { if (!response.ok) throw new Error('No location suggestion'); return response.json(); })
    .then(result => { const country = result.detected_values?.country?.handle; if (country && /^[A-Z]{2}$/.test(country)) show(country); else dialog.dataset.status = 'no-location-result'; })
    .catch(() => { dialog.dataset.status = 'location-unavailable'; })
    .finally(() => clearTimeout(timeout));
})();


